import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
  Alert,
  PanResponder,
  Animated,
} from "react-native";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";

export default class Pannable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // pan: new Animated.ValueXY()
    };
  }

  async componentDidMount() {
    this.pan = new Animated.ValueXY();
    this.panResponder = PanResponder.create({
      // Ask to be the responder:
      onStartShouldSetPanResponder: (evt, gestureState) => {
        return !(gestureState.dx === 0 && gestureState.dy === 0);
        // true,
      },
      onStartShouldSetPanResponderCapture: (evt, gestureState) => {
        return !(gestureState.dx === 0 && gestureState.dy === 0);
        // false, //true,
      },
      onMoveShouldSetPanResponder: (evt, gestureState) => {
        return !(gestureState.dx === 0 && gestureState.dy === 0);
        // true,
      },
      onMoveShouldSetPanResponderCapture: (evt, gestureState) => {
        return !(gestureState.dx === 0 && gestureState.dy === 0);
        // false, //true,
      },
      onPanResponderGrant: (evt, gestureState) => {
        // gestureState.d{x,y} will be set to zero now
        this.pan.setOffset(this.pan.__getValue());
        // this.pan.setOffset({
        //   x: this.pan.x._value,
        //   y: this.pan.y._value
        // });
        this.pan.setValue({ x: 0, y: 0 });
      },
      onPanResponderMove: (evt, gestureState) => {
        if (this.props.onPan) {
          this.props.onPan(gestureState);
          return;
        }

        // multitouches
        const touches = evt.nativeEvent.touches;
        if (touches.length >= 2) {
          // We have a pinch-to-zoom movement
          // Track locationX/locationY to know by how much the user moved their fingers
          console.log(touches);

          // touches[0].changedTouches

          // Array [
          //   Object {
          //     "changedTouches": Array [
          //       [Circular],
          //       Object {
          //         "identifier": 2,
          //         "locationX": 25.5,
          //         "locationY": 76.5,
          //         "pageX": 129,
          //         "pageY": 498.5,
          //         "target": 3639,
          //         "timestamp": 14192060.857306002,
          //       },
          //     ],
          //     "identifier": 1,
          //     "locationX": 285,
          //     "locationY": 249,
          //     "pageX": 285,
          //     "pageY": 397.5,
          //     "target": 293,
          //     "timestamp": 14192060.857306002,
          //     "touches": [Circular],
          //   },
          //   Object {
          //     "identifier": 2,
          //     "locationX": 25.5,
          //     "locationY": 76.5,
          //     "pageX": 129,
          //     "pageY": 498.5,
          //     "target": 3639,
          //     "timestamp": 14192060.857306002,
          //   },
          // ]
          return;
        }

        // The most recent move distance is gestureState.move{X,Y}
        // The accumulated gesture distance since becoming responder is
        // gestureState.d{x,y}
        // console.log(this.pan.y._value)
        // console.log(evt)
        console.log(gestureState.dy, gestureState.moveY);
        Animated.event([
          null,
          {
            dx: this.pan.x,
            dy: this.pan.y,
            useNativeDriver: !ENV.WEB,
          },
        ])(evt, gestureState); // <<--- INVOKING HERE!
      },
      // onPanResponderMove: Animated.event([
      //     null,
      //     { dx: this.pan.x, dy: this.pan.y }
      //   ]),
      onPanResponderTerminationRequest: (evt, gestureState) => true,
      onPanResponderRelease: (evt, gestureState) => {
        this.pan.flattenOffset();
        return;
        // The user has released all touches while this view is the
        // responder. This typically means a gesture has succeeded
        console.log("release:", gestureState.moveY, this.props.yThreshold);
        if (
          !!this.props.yThreshold &&
          gestureState.moveY < this.props.yThreshold
        ) {
          this.pan.flattenOffset();
        } else {
          this.pan.flattenOffset();
          Animated.spring(this.pan, {
            toValue: { x: 0, y: 0 },
            friction: 10,
            useNativeDriver: !ENV.WEB,
          }).start(() => {});
        }
      },
      onPanResponderTerminate: (evt, gestureState) => {
        // Another component has become the responder, so this gesture
        // should be cancelled
      },
      onShouldBlockNativeResponder: (evt, gestureState) => {
        // Returns whether this component should block native components from becoming the JS
        // responder. Returns true by default. Is currently only supported on android.
        return true;
      },
    });
  }

  render() {
    return (
      <View style={[styles.container, this.props.style]}>
        {!!this.pan && (
          <Animated.View
            useNativeDriver={true}
            style={[
              styles.content,
              // {transform: [{ translateX: this.pan.x }, { translateY: this.pan.y }]},
            ]}
            {...this.panResponder.panHandlers}
          >
            {this.props.children}
          </Animated.View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // flexDirection: 'column',
    justifyContent: "center",
    alignItems: "stretch",
    borderWidth: 12,
    borderColor: "skyblue",
  },
  content: {
    flex: 1,
    borderWidth: 12,
    borderColor: "orange",
  },
});
